import type { RequestOptions } from "../common/server";
import type { UserShortcutPermissionsJs } from "@/generated/models";
import { server } from "./server";

export async function getUserShortcutPermissions(shortcut: string, { signal }: RequestOptions = {}) {
  const response = await server.get(`permissions/GetUserShortcutPermissions/${shortcut}`, { signal });
  const permissionsJs = await response.json() as UserShortcutPermissionsJs;
  return permissionsJs;
}
